export const HEADERS = [
	'No',
	'Username',
	'Email',
	'Contract Type',
	'Supperior',
	'Role',
	'Info',
];
